import { LogglyTracker } from 'loggly-jslogger';
import { detectWVUSEnvUrl, getKeyByValue, requiredParamsProvided } from './helper';

const LEVELS = {
  DEBUG: 100,
  INFO: 200,
  NOTICE: 250,
  WARNING: 300,
  ERROR: 400,
  CRITICAL: 500,
  ALERT: 550,
  EMERGENCY: 600
}; 
Object.freeze(LEVELS);

export const LEVEL_NAMES = {
  DEBUG: "debug",
  INFO: "info",
  NOTICE: "notice",
  WARNING: "warning",
  ERROR: "error",
  CRITICAL: "critical",
  ALERT: "alert",
  EMERGENCY: "emergency"
};
Object.freeze(LEVEL_NAMES);

class WvusClientLogger {
    constructor(opts = {}) {
      
      if (!requiredParamsProvided(Object.keys(opts), ['logglyKey', 'webProperty'])) {
        throw new Error('Missing required parameter');
      }
      
      // create helper function to check required params
      const logglyKey = opts.logglyKey;
      const sendConsoleErrors = ('sendConsoleErrors' in opts) ? opts.sendConsoleErrors : true; 
      this.separateInstance = ('separateInstance' in opts) ? opts.separateInstance : false;
      this.webProperty = opts.webProperty || '';
      this.env = opts.env || detectWVUSEnvUrl();
      this.source = opts.source || window?.document?.title || 'WVUS Client Logger';
      this.sourceUrl = opts.sourceUrl || window?.document?.location?.href || '';
      
      this._LTracker = this.setLTrackerInstance({
        'logglyKey': logglyKey,
        'sendConsoleErrors': sendConsoleErrors,
        'tag': 'wvus-client-logger'
      }, this.separateInstance);
    }

    setLTrackerInstance(params, separateInstance) {
      const trackerInstance = new LogglyTracker();
      
      if (!separateInstance && window._LTracker) {
        window._LTracker.push(params);
        return window._LTracker;
      } else if (!separateInstance && !window._LTracker) {
        window._LTracker = trackerInstance;
      }

      trackerInstance.push(params);

      return trackerInstance;
    }

    getTrackerInstance() {
      return this._LTracker;
    }

    /* 
      log message to loggly
      message - required param, won't log without it
      level name - defaults to info 
      source - defaults to this.sourceUrl
    */  
    
    log(message, level_name = LEVEL_NAMES.INFO, source = this.sourceUrl) {
      if (!message) {
        console.warn('Cannot log without a log message argument.');
        return;
      }

      const log_level_name = Object.values(LEVEL_NAMES).includes( level_name) ? level_name : LEVEL_NAMES.INFO;
      const log_level = LEVELS[getKeyByValue(LEVEL_NAMES, log_level_name)];
      const user_agent = window.navigator.userAgent;
      const log_message = typeof(message) != "string" ? JSON.stringify(message, Object.getOwnPropertyNames(message)) : message; 

      /* Log the following information to loggly:
        channel - wvus_logger_{webproperty}_{environment} 
        level - The number representing the log level  ( will be provided )
        level_name - The log level name ( for example: LEVEL_NAMES.INFO or LEVEL_NAMES.WARNING etc ).
        message - serializable data - ( object, array, string, number, boolean, etc. ) - ( required )
        user_agent - ( include the user agent of the current browser instance ). 
      */
      
      this._LTracker.push({
        'channel': `wvus_logger_${this.webProperty}_${this.env}`,
        'source_url': source,
        'level': log_level,
        'level_name': log_level_name,
        'message': log_message,
        'user_agent': user_agent

      });
    }

    getLogLevelNames() {
      return LEVEL_NAMES;
    }
}

export default WvusClientLogger; 